import { CSSProperties, ReactNode, useEffect, useRef, useState } from 'react';
import styles from './Pill.module.css'
import ScrollingOverflow from '../textOverflow/ScrollingOverflow';
import { isElementScrollableById } from '../../helpers/DocumentUtilsHelper';
import Checkbox from '../checkbox/Checkbox';

type PeelProps = {
    label: ReactNode;
    icon?: string;
    badgeColor?: string;
    labelColor?: string;
    badgeNumber?: number;
    selected?: boolean;
    enableScrollingOverflow?: boolean;
    enableBreaklineOverflow?: boolean;
    maxWidth?: number;
    style?: CSSProperties;
    invisibleTextStyle?: CSSProperties;
    iconStyle?: CSSProperties;
    lableStyle?: CSSProperties;
    className?: string;
    id?: string;
    alignPill?: boolean;
    centerAlignText?: boolean;
    loading?: boolean;
    onClick?: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
    onIconClick?: () => void;
}

function Pill({ label, icon, selected, enableScrollingOverflow, loading, invisibleTextStyle,
        alignPill, badgeColor, badgeNumber, style, iconStyle, id, centerAlignText = true,
        lableStyle, labelColor, enableBreaklineOverflow, maxWidth, className, onIconClick, onClick }: PeelProps) {
    
    const [shouldScroll, setShouldScroll] = useState(false)
    const ref = useRef<HTMLDivElement>(null)
    
    function beforeIconClick(e: React.MouseEvent<HTMLImageElement, MouseEvent>) {
        e.stopPropagation();
        onIconClick ? onIconClick() : (onClick && onClick(e));
    }

    useEffect(() => {
        if (enableScrollingOverflow && ref.current)
            setShouldScroll(isElementScrollableById(ref.current, false, 'Width'))
    }, [label, enableScrollingOverflow, ref])

    return (
        <div 
            id={id}
            className={`${styles.layout} ${className}`} 
            onClick={onClick}
            style={{ 
                backgroundColor: selected ? 'var(--primary-color)' : '', 
                overflow: enableScrollingOverflow ? 'hidden' : '',
                maxWidth: enableBreaklineOverflow || enableScrollingOverflow ? maxWidth || '100px' : '',
                ...style 
            }}
        >
            <div 
                ref={ref} 
                className={enableScrollingOverflow ? styles.invisiblelabel : styles.label}
                style={{ textAlign: centerAlignText ? 'center' : 'right', ...lableStyle, ...invisibleTextStyle }}
            >
                <span style={{ color: selected ? 'white' : (!shouldScroll ? labelColor || 'black' : '') }}>{label}</span>

                {(enableScrollingOverflow && !enableBreaklineOverflow) &&
                <ScrollingOverflow
                    onClick={() => {}}
                    show={shouldScroll}
                    element={ref.current!}
                    text={label?.toString() || ''}
                    style={{ top: '0px', color: 'black' }}
                    scrollingWidth={maxWidth || ref.current?.clientWidth || 0}
                />}
            </div>

            {badgeColor && 
            <div 
                className={styles.badge} 
                style={{ 
                    backgroundColor: badgeColor, 
                    alignSelf: alignPill ? 'flex-start' : '', 
                    marginTop: alignPill ? '2px' : '' 
                }}
            />}
            
            {badgeNumber && <div style={{ fontSize: '10px' }}>{badgeNumber}</div>}

            {(icon && !loading) && 
            <img src={icon} height={12} width='auto' alt='pill' draggable={false} onClick={beforeIconClick} style={{ ...iconStyle }}/>}

            {loading && <Checkbox checked={false} loading style={{ marginTop: '-4px', marginRight: '-4px' }}/>}
        </div>
    )
}

export default Pill;